import {SvgIcon, SvgIconProps} from "@mui/material";

export const CircleShapeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <circle
            cx="12"
            cy="12"
            r="9"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        />
    </SvgIcon>
);
